// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { headerStyles, HEADER_BREAKPOINT } from "@steiner/Overrides/Pages/Header";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export const headerBackgroundCss = css`
    background-image: linear-gradient(180deg, ${color("common.ui18")} 0%, ${color("primary")} 100%);
`;

headerStyles.page = {
    fullWidth: [true, true, true, true, true],
    css: css`
        z-index: ${getProp("theme.zIndex.header")};
        padding: 12px 0 0;
        ${headerBackgroundCss}

        ${xScreen("lte", HEADER_BREAKPOINT)} {
            padding: 0;
        }
    `,
};
